import { Preference } from 'sr-types/lib/search/v1/graphql';
import { PROD_DATA_LIST_KEY } from './productionDataListConfigConstants';
import type { ProductionDataListConfigurationState } from './types';

type WorkspaceDataCardPreferenceReturnType = {
    workspacePreferenceValue: Partial<ProductionDataListConfigurationState>;
    workspacePreferences: Preference | null;
};

export const getWorkspaceDataCardPreference = (preferences: Preference[]): WorkspaceDataCardPreferenceReturnType => {
    const workspacePreferences: Preference | null = (preferences || []).find((pref) => pref.key === PROD_DATA_LIST_KEY);
    const workspacePreferenceValue: Partial<ProductionDataListConfigurationState> = workspacePreferences
        ? JSON.parse(workspacePreferences.value)
        : {};
    return { workspacePreferenceValue, workspacePreferences };
};
